import dayjs from "dayjs";
import weekday from "dayjs/plugin/weekday";
import weekOfYear from "dayjs/plugin/weekOfYear";

import CalendarFilteringPanel from "./CalendarFilteringPanel";
import CalendarMonthDayItem from "./CalendarMonthDayItem";
import CalendarSingleDay from "./CalendarSingleDay";
import CalendarWeekdays from "./CalendarWeekdays";
import AddNewCalendarRecord from "./AddNewCalendarRecord";
import { hDeepCopy } from "@/utils/helpers";

dayjs.extend(weekday);
dayjs.extend(weekOfYear);
// import locale from 'dayjs/locale/pl';
export default {
  name: "TheCalendar",
  components: {
    CalendarFilteringPanel,
    CalendarMonthDayItem,
    CalendarSingleDay,
    CalendarWeekdays,
    AddNewCalendarRecord
  },
  data() {
    return {
      isOpenDayCalendar: false,
      selectedDate: dayjs(),
      selectedDateForDayCalendar: "",
      filters: {}
    };
  },
  watch: {
    month: {
      handler() {
        this.getCalendarEvents();
      }
    }
  },
  computed: {
    isLoading() {
      return this.$store.getters["global/pendingAsyncStoreActions"].includes([
        "callPlanner/getCalendarEventsList"
      ]);
    },
    projectList() {
      return this.$store.getters["client/projects/list"]?.records;
    },
    colorsForEventsPerUser() {
      const uniqueUserUuids = new Set();
      const eventColors = [];
      this.eventsList.forEach(event => {
        const isDuplicate = uniqueUserUuids.has(event.user_uuid);
        if (event.user_uuid && event.username && !isDuplicate) {
          uniqueUserUuids.add(event.user_uuid);
          eventColors.push({
            username: event.username,
            userUuid: event.user_uuid,
            color: `hsla(${~~(360 * Math.random())},70%,70%,0.8)`
          });
        } else {
          return false;
        }
      });
      return eventColors;
    },
    agentsAbleToCall() {
      return this.$store.getters["user/agent/agentsBelongsToUserlist"].records.filter(
        el => el.massdial4call === true
      );
    },
    eventsList() {
      return this.$store.getters["callPlanner/calendarEventsList"];
    },
    filteredEvenetsList() {
      let eventListCopy = hDeepCopy(this.eventsList);
      if (this.filters.isWithoutTry) {
        eventListCopy = eventListCopy.filter(item => !item.trying_stamp);
      }
      if (this.filters.isWithTry) {
        eventListCopy = eventListCopy.filter(item => !!item.trying_stamp);
      }
      if (this.filters.isFilterByUser?.length > 0) {
        eventListCopy = eventListCopy.filter(item =>
          this.filters.isFilterByUser.includes(item.user_uuid)
        );
      }
      if (this.filters.isFilterByProject?.length > 0) {
        eventListCopy = eventListCopy.filter(item =>
          this.filters.isFilterByProject.includes(item.project_id)
        );
      }
      if (this.filters.isShowAll) {
        return eventListCopy;
      } else {
        eventListCopy = eventListCopy.filter(item => !!item.active);
      }
      return eventListCopy;
    },
    today() {
      return dayjs();
    },
    month() {
      return Number(this.selectedDate.format("M"));
    },
    year() {
      return Number(this.selectedDate.format("YYYY"));
    },
    numberOfDaysInMonth() {
      return dayjs(this.selectedDate).daysInMonth();
    },
    selectedMonthDays() {
      return [...Array(this.numberOfDaysInMonth)].map((day, index) => {
        return {
          date: dayjs(`${this.year}-${this.month}-${index + 1}`).format("YYYY-MM-DD"),
          isCurrentMonth: true
        };
      });
    },
    previousMonthDays() {
      const firstDayOfTheMonthWeekday = this.getWeekday(this.selectedMonthDays[0].date);
      const previousMonth = dayjs(`${this.year}-${this.month}-01`).subtract(1, "month");
      const visibleNumberOfDaysFromPreviousMonth = firstDayOfTheMonthWeekday
        ? firstDayOfTheMonthWeekday - 1
        : 6;
      const previousMonthLastMondayDayOfMonth = dayjs(this.selectedMonthDays[0].date)
        .subtract(visibleNumberOfDaysFromPreviousMonth, "day")
        .date();

      return [...Array(visibleNumberOfDaysFromPreviousMonth)].map((day, index) => {
        return {
          date: dayjs(
            `${previousMonth.year()}-${previousMonth.month() +
              1}-${previousMonthLastMondayDayOfMonth + index}`
          ).format("YYYY-MM-DD"),
          isCurrentMonth: false,
          isPreviousMonth: true
        };
      });
    },
    nextMonthDays() {
      const LastDayOfTheMonthWeekday = this.getWeekday(
        this.selectedMonthDays[this.selectedMonthDays.length - 1].date
      );
      const nextMonth = dayjs(`${this.year}-${this.month}-01`).add(1, "month");
      const visibleNumberOfDaysFromNextMonth = LastDayOfTheMonthWeekday
        ? 7 - LastDayOfTheMonthWeekday
        : 0;

      return [...Array(visibleNumberOfDaysFromNextMonth)].map((day, index) => {
        return {
          date: dayjs(`${nextMonth.year()}-${nextMonth.month() + 1}-${index + 1}`).format(
            "YYYY-MM-DD"
          ),
          isCurrentMonth: false,
          isNextMonth: true
        };
      });
    },
    daysToRenderInCalendar() {
      return [...this.previousMonthDays, ...this.selectedMonthDays, ...this.nextMonthDays];
    }
  },
  methods: {
    updateFilters(filters) {
      this.filters = filters;
    },
    getWeekday(date) {
      return dayjs(date).weekday();
    },
    setNewDate(date, isChangeByDay) {
      if (isChangeByDay) {
        this.selectedDateForDayCalendar = date.format("YYYY-MM-DD");
      }
      this.selectedDate = date;
    },
    openDayCalendar(date) {
      this.selectedDate = dayjs(date);
      this.selectedDateForDayCalendar = date;
      this.isOpenDayCalendar = true;
    },
    openMonthCalendar() {
      this.isOpenDayCalendar = false;
    },
    getCalendarEvents() {
      this.$store.dispatch("callPlanner/getCalendarEventsList", {
        startDate: this.selectedMonthDays[0].date,
        endDate: this.selectedMonthDays[this.selectedMonthDays.length - 1].date
      });
    }
  },
  mounted() {
    this.getCalendarEvents();
  }
};
